module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<p class=\"title\"><%- model.title; %></p>\n<p class=\"intro\"><%- model.intro; %></p>\n<p class=\"mail\"><a href=\"mailto:<%- model.email; %>\"><%- model.email; %></a></p>\n<p class=\"phone\"><%- model.phone; %></p>\n<p class=\"contactForm\"><a href=\"<%- model.route.data; %>\">Kontaktformular</a></p>\n<div class=\"info\">\n<%- model.info; %>\n</div>\n</div>"
  , __filename = "components/templates/headPanel/sidePanels/contact.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n<p class=\"title\">")
    ; __line = 2
    ; __append( model.title )
    ; __append("</p>\n<p class=\"intro\">")
    ; __line = 3
    ; __append( model.intro )
    ; __append("</p>\n<p class=\"mail\"><a href=\"mailto:")
    ; __line = 4
    ; __append( model.email )
    ; __append("\">")
    ; __append( model.email )
    ; __append("</a></p>\n<p class=\"phone\">")
    ; __line = 5
    ; __append( model.phone )
    ; __append("</p>\n<p class=\"contactForm\"><a href=\"")
    ; __line = 6
    ; __append( model.route.data )
    ; __append("\">Kontaktformular</a></p>\n<div class=\"info\">\n")
    ; __line = 8
    ; __append( model.info )
    ; __append("\n</div>\n</div>")
    ; __line = 10
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/headPanel/sidePanels/contact.ejs

}